import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalShell from 'components/common/ModalShell';
import CreateDeviceForm from './CreateDeviceForm';

// The one "add a device by hand" dialog, shared by the Sources tab and the
// device-filter editor so both entry points keep one set of fields, one
// validation story and one 409 message. The caller owns the request and what
// happens to the created device (the editor pre-marks it into the active list).

type AddDeviceModalProps = {
  isOpen: boolean;
  onClose: () => void;
  // Resolves when the device is created; a rejection keeps the form open
  // with the typing intact.
  onCreate: (payload: { external_id: string; name?: string }) => Promise<void>;
  // Pre-fills the ID field (the editor passes the unmatched search term).
  initialExternalId?: string;
  // Wraps testids so each surface stays addressable in tests.
  testIdPrefix: string;
};

const AddDeviceModal = ({
  isOpen,
  onClose,
  onCreate,
  initialExternalId,
  testIdPrefix,
}: AddDeviceModalProps) => {
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <ModalShell title={t('Add source')} onClose={onClose}>
      <div
        className="flex flex-col gap-4"
        data-testid={`${testIdPrefix}-create`}
      >
        <span className="text-sm text-ui-text-secondary-text">
          {t("Add a source that hasn't reported yet")}
        </span>
        <CreateDeviceForm
          initialExternalId={initialExternalId}
          onSubmit={async (payload) => {
            await onCreate(payload);
            onClose();
          }}
          onCancel={onClose}
          testIdPrefix={testIdPrefix}
        />
      </div>
    </ModalShell>
  );
};

export default AddDeviceModal;
